export default __webpack_public_path__ + "static/media/iconmonstr-refresh-1.7fde178d.svg";